module.exports = __webpack_public_path__ + "img/fusion580.6b43cb63.png";